import React, { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";

const RequestForChnageModal = (props) => {
    const navigate = useNavigate();
    const sucessModal = () => {
        props.parenttoggle();
        props.toggle();
        props.refresh();
        const module_id = JSON.parse(localStorage.getItem("user"))?.moduleMapInfo?.module_id;
        if (module_id == 2) {
            navigate("/requests/cashify-my-requests");
        }else{
            navigate("/requests/my-requests")
        }
       
    }


    return (
        <Fragment>
            <Modal isOpen={props.isOpen} toggle={()=>sucessModal()} size="md">
                <ModalHeader className="border-0" toggle={()=>sucessModal()}>Policy Request Submitted</ModalHeader>
                <ModalBody >
                    
                        Request for change submitted successfully!<br />
                        Please note the ticket number for the request  <b>{props.ticketID} </b>.<br />
                        Kindly check the status under <b>My Requests</b> section of the account<br />
                   
                    <ModalFooter className="border-0">
                        <Button color="primary" className="d-flex justify-content-center" onClick={() => sucessModal()}>OK</Button>
                    </ModalFooter>


                </ModalBody>


            </Modal>
        </Fragment>
    );
};

export default RequestForChnageModal;